import { gql } from '@apollo/client'
import { useMatch } from '@reach/router'
import { useProjectId } from '@btime/react-session'
import React from 'react'

import { accountsClient, cache } from '../../utils/apollo/api'
import { setProjectId } from '../../utils/session/sessionStorage'
import { useQuery } from '../../utils/apollo/_helpers/useQuery'
import { useReloadLoggedUser } from '../../utils/session/reloadLoggedUser'
import Loading from '../../packages/kiti/components/helpers/Loading'

const QUERY = gql`
  query Projects {
    projects(limit: 2) {
      id
    }
  }
`

const SingleProjectChecker = ({ children }) => {
  const reloadUser = useReloadLoggedUser()

  const { data, ...state } = useQuery(QUERY, {
    client: accountsClient,
    fetchPolicy: 'cache-first'
  })

  const projects = data?.projects || []
  const isSingleProject = projects.length === 1

  React.useEffect(() => {
    if (isSingleProject && !state.loading) {
      setProjectId(projects[0].id)
      setTimeout(() => {
        reloadUser()
        cache.reset()
      }, 222)
    }
  }, [projects.length])

  return !!isSingleProject || state.loading ? <Loading /> : children
}

const Wrapper = props => {
  const isHomePage = useMatch('/home')
  const projectId = useProjectId()
  if (isHomePage || projectId) return props.children
  return <SingleProjectChecker {...props} />
}

export default Wrapper
